import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { EEventType } from '../../types/events';
import { ESocialType, ESocialResponseType, EAuthenticateStatus, EAuthenticateError } from '../../types/social';
import { SocialIconOk, SocialIconVk, SocialIconFb, SocialIconG, SocialIconMail, SocialIconApple } from './social_icons';
import { Context as ResponsiveContext } from '../Responsive';
import { Tooltip, ETooltipSize } from '../Tooltip';
import { SocialButton } from '../SocialButton';
import * as styles from './styles.css';
import { EDeviceType } from '../../types/device';
import { trackSocialButtonClick } from '../../utils/tracking';
var SOCIAL_NETWORKS = [{
  type: ESocialType.VK,
  name: 'ВКонтакте',
  icon: SocialIconVk,
  color: '#5a79aa'
}, {
  type: ESocialType.Facebook,
  name: 'Facebook',
  icon: SocialIconFb,
  color: '#39579a'
}, {
  type: ESocialType.Google,
  name: 'Google+',
  icon: SocialIconG,
  color: '#e25f50'
}, {
  type: ESocialType.OK,
  name: 'Одноклассники',
  icon: SocialIconOk,
  color: '#ec7c21'
}, {
  type: ESocialType.MailRu,
  name: 'Почта Mail.Ru',
  icon: SocialIconMail,
  color: '#3298e5'
}, {
  type: ESocialType.AppleID,
  name: 'Apple ID',
  icon: SocialIconApple,
  color: '#000000'
}];
export var Social = /*#__PURE__*/function (_React$Component) {
  _inherits(Social, _React$Component);

  var _super = _createSuper(Social);

  function Social() {
    var _this;

    _classCallCheck(this, Social);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleSocialClick", function (type) {
      window._socialResponse = _this.handleSocialResponse;
      /* DEPRECATED */

      window.socialLogOnStart = _this.handleSocialSuccess(type);
      window.showNeedEmailPopup = _this.handleSocialEmailRequired;
      window.showNeedMergeEmailPopup = _this.handleSocialEmailTaken;
      window.showErrorSocialAuth = _this.handleSocialError(type);

      _this.props.emit(EEventType.SocialButtonClick, {
        type: type
      });

      _this.props.open({
        socialType: type
      });

      trackSocialButtonClick(type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSocialSuccess", function (type) {
      return function (socialLoginId, email, token, userCreated) {
        _this.props.socialAuthenticate({
          socialType: type,
          socialLoginId: socialLoginId,
          email: email,
          token: token,
          userCreated: userCreated
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSocialEmailRequired", function (socialType, socialLoginId) {
      _this.props.socialAuthenticateEmailRequired({
        socialLoginId: socialLoginId,
        socialType: socialType,
        email: '',
        phone: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSocialEmailTaken", function (email, socialLoginId, socialType) {
      _this.props.socialAuthenticateEmailTaken({
        email: email,
        socialLoginId: socialLoginId,
        socialType: socialType
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSocialError", function (type) {
      return function () {
        _this.props.socialAuthenticateError(type);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSocialResponse", function () {
      for (var _len2 = arguments.length, response = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        response[_key2] = arguments[_key2];
      }

      var type = response[0],
          data = response[1];

      switch (type) {
        case ESocialResponseType.UserNotFound:
          {
            var socialLoginId = data.socialLoginId,
                socialType = data.socialType,
                email = data.email,
                phone = data.phone;

            _this.props.socialAuthenticateEmailRequired({
              socialLoginId: socialLoginId,
              socialType: socialType,
              email: email,
              phone: phone
            });

            break;
          }
      }
    });

    return _this;
  }

  _createClass(Social, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$social$au = _this$props.social.authenticate,
          status = _this$props$social$au.status,
          errorType = _this$props$social$au.errorType,
          error = _this$props$social$au.error,
          disabledSocials = _this$props.disabledSocials;
      var isError = status === EAuthenticateStatus.Failed && (!errorType || ![EAuthenticateError.EmailRequired, EAuthenticateError.EmailTaken].includes(errorType));
      var enabledNetworks = SOCIAL_NETWORKS.filter(function (_ref) {
        var type = _ref.type;
        return !disabledSocials.includes(type);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, /*#__PURE__*/React.createElement(ResponsiveContext.Consumer, null, function (deviceType) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          size: ETooltipSize.M,
          content: isError ? error : undefined,
          hideDelay: deviceType === EDeviceType.Phone ? 3000 : undefined
        }, /*#__PURE__*/React.createElement("div", {
          className: styles['buttons']
        }, enabledNetworks.map(function (network) {
          var IconComponent = network.icon;
          return /*#__PURE__*/React.createElement(SocialButton, {
            key: "social_button-".concat(network.name),
            color: network.color,
            title: network.name,
            onClick: function onClick() {
              return _this2.handleSocialClick(network.type);
            },
            compact: enabledNetworks.length >= 6
          }, /*#__PURE__*/React.createElement(IconComponent, null));
        })));
      }));
    }
  }]);

  return Social;
}(React.Component);